import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchGetInfrastructureNearbyBlock,
  IGetInfrastructureNearbyBlockRequest,
  TGetInfrastructureNearbyBlockResponse
} from '../../../repositories/price-estimator/v2/get-infrastructure-nearby-block';
import { BadRequestError } from '@cian/valuation-utils-component';
import {
  IInfrastructureResponse
} from "../../../repositories/price-estimator/entities/infrastructure_nearby/InfrastructureResponse";


export const onInfrastructureObjectsFetch = async ({
  address,
}: IGetInfrastructureNearbyBlockRequest): Promise<IInfrastructureResponse> => {
  try {
    const response = (await fetchGetInfrastructureNearbyBlock({
      httpApi: getHttpApi(),
      parameters: {
        address,
      },
      config: {
        requestConfig: { withCredentials: true },
      },
    })) as TGetInfrastructureNearbyBlockResponse;

    if (response.statusCode !== 200) {
      throw new BadRequestError({
        domain: 'onInfrastructureObjectsFetch.ts',
        message: response.response.message as string,
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }

    return response.response as IInfrastructureResponse;
  } catch (err) {
    getLogger().error(err);

    return {
      infrastructure: undefined,
      metro: [],
      roads: [],
    };
  }
};
